import { useMutation } from 'react-query';

import { deleteReport as mutationFn } from 'api/endPoints/deleteReport';

export const useMutationDeleteReport = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    reportId: string;
}
